import angular from "angular"
import trainRouteService from "../trainRoutesService/trainRoutesService";
import angularMoment from "angular-moment";

let mod = angular
    .module('trainRoute', [
        trainRouteService,
        angularMoment
    ])
    .run(['$templateCache', function ($templateCache) {
        $templateCache.put('train-route-popup.html', require('./train-route-popup.html'));
    }])
    .component('trainRoute', {
        template: require('./trainRoute.html'),
        controller: ['trainRoutesService', 'moment', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(trainRoutesService, moment) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.route = $ctrl.resolve.route;
        $ctrl.train = $ctrl.resolve.train;
        $ctrl.routes = null;
        if ($ctrl.train.routes) {
            let r = parseWaitingTimes($ctrl.train.routes);
            r = setNewDays(r);
            r = setPoints(r);
            $ctrl.routes = r;
            $ctrl.loadingStatus = 'success';
        } else {
            getTrainRoutes();
        }
    };

    $ctrl.retryRequest = function () {
        getTrainRoutes();
    };

    function getTrainRoutes() {
        $ctrl.loadingStatus = 'loading';
        $ctrl.loadErrorMessage = null;
        trainRoutesService
            .getTrainRoutes(
                $ctrl.route.depStation.code,
                $ctrl.route.depDate,
                $ctrl.train.number
            )
            .then(
                function (routes) {
                    $ctrl.train.routes = routes;
                    let r = parseWaitingTimes(routes);
                    r = setNewDays(r);
                    r = setPoints(r);
                    $ctrl.routes = r;
                    $ctrl.loadingStatus = 'success';
                },
                function (error) {
                    $ctrl.loadingStatus = 'error';
                    $ctrl.loadErrorMessage = error.data.messages[0];
                }
            )
    }

    function parseWaitingTimes(routes) {
        for (let i = 0; i < routes.length; i++){
            for (let j = 0; j < routes[i].Stop.length; j++) {
                if (routes[i].Stop[j].WaitingTime) {
                    let waitingTime = routes[i].Stop[j].WaitingTime;
                    waitingTime = waitingTime.split(':');
                    routes[i].Stop[j].waitingHours = +waitingTime[0];
                    routes[i].Stop[j].waitingMinutes = +waitingTime[1];
                }
            }
        }
        return routes;
    }

    function setNewDays(routes) {
        let routeDepStationInfo = getRouteStation(routes, $ctrl.route.depStation.code);

        if (!routeDepStationInfo) {
            for (let i = 0; i < $ctrl.route.depStation.childStations.length; i++) {
                routeDepStationInfo = getRouteStation(routes, $ctrl.route.depStation.childStations[i].StationCode);
                if (routeDepStationInfo) {
                    break;
                }
            }
        }

        if (! routeDepStationInfo) {
            return routes;
        }

        let routeDepStation = routeDepStationInfo.station;

        let diffWithDepDate = -routeDepStation.Days;

        let startDate = moment($ctrl.route.depDate).add(diffWithDepDate, 'days');

        for (let i = 0; i < routes.length; i++) {
            let prevDay = 0;
            for (let j = 0; j < routes[i].Stop.length; j++) {
                if (routes[i].Stop[j].Days == null) {
                    continue;
                }
                let day = +routes[i].Stop[j].Days;
                if (day != prevDay) {
                    prevDay = day;
                    routes[i].Stop[j].newDay = startDate.clone().add(day, 'days')
                }
            }
        }

        return routes;
    }

    function getRouteStation(routes, stationCode) {
        for (let i = 0; i < routes.length; i++){
            for (let j = 0; j < routes[i].Stop.length; j++) {
                if (routes[i].Stop[j].Code == stationCode) {
                    return {
                        routeInd: i,
                        stationInd: j,
                        station: routes[i].Stop[j]
                    }
                }
            }
        }
        return null;
    }

    function setPoints(routes) {

        let depStInfo = getRouteStation(routes, $ctrl.route.depStation.code);
        let arrStInfo = getRouteStation(routes, $ctrl.route.arrStation.code);

        if (!depStInfo) {
            for (let i = 0; i < $ctrl.route.depStation.childStations.length; i++) {
                depStInfo = getRouteStation(routes, $ctrl.route.depStation.childStations[i].StationCode);
                if (depStInfo) {
                    break;
                }
            }
        }

        if (!arrStInfo) {
            for (let i = 0; i < $ctrl.route.arrStation.childStations.length; i++) {
                arrStInfo = getRouteStation(routes, $ctrl.route.arrStation.childStations[i].StationCode);
                if (arrStInfo) {
                    break;
                }
            }
        }

        if (depStInfo && arrStInfo) {
            if (depStInfo.stationInd - 1 >= 0) {
                routes[depStInfo.routeInd].Stop[depStInfo.stationInd - 1].status = 'before-start';
            }
            routes[arrStInfo.routeInd].Stop[arrStInfo.stationInd - 1].status = 'before-end';
            routes[depStInfo.routeInd].Stop[depStInfo.stationInd].status = 'start';
            routes[arrStInfo.routeInd].Stop[arrStInfo.stationInd].status = 'end';

            if (depStInfo.routeInd == arrStInfo.routeInd) {
                for (let i = depStInfo.stationInd + 1; i < arrStInfo.stationInd - 1; i++) {
                    routes[depStInfo.routeInd].Stop[i].status = 'inner';
                }
            } else {

                let depRouteEndStInd = null;

                for (let i = 0; i < routes[depStInfo.routeInd].Stop.length; i++) {
                    if (routes[depStInfo.routeInd].Stop[i].Code == routes[arrStInfo.routeInd].Stop[0].Code) {
                        depRouteEndStInd = i;
                        break;
                    }
                }

                for (let i = depStInfo.stationInd + 1; i <= depRouteEndStInd; i++) {
                    routes[depStInfo.routeInd].Stop[i].status = 'inner';
                }

                for (let i = 0; i < arrStInfo.stationInd - 1; i++) {
                    routes[arrStInfo.routeInd].Stop[i].status = 'inner';
                }
            }
        }

        return routes;
    }

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/trainRoute/trainRoute.js